import { CheckIcon, PencilIcon } from '@heroicons/react/24/solid';
import { useEffect, useState } from 'react';
import type { ReactSelectOption } from '../../../../types/Constants';
import { HasPermission } from '../../../Permission/HasPermission';
import { HookForm } from '../../../UI/HookForm/Form';
import { HookInput } from '../../../UI/HookForm/Form/Input';
import { HookFormProvider } from '../../../UI/HookForm/Provider';
import { HookReactSingleSelect } from '../../HookForm/Form/ReactSelect';

export interface SingleEditableFieldProps {
  name: string;
  inputValue: string;
  disabled?: boolean;
  options?: ReactSelectOption[];
  type?: 'input' | 'select';
  permission?: string;
  isLoading: boolean;
  isSuccess: boolean;
  maxLength?: number;
  minLength?: number;
  onSubmit: (data: any) => void;
}
export const SingleEditableField = (props: SingleEditableFieldProps) => {
  const { name, inputValue, options, disabled, type = 'input', permission, isLoading, onSubmit, isSuccess, maxLength, minLength } = props;
  const [isEdit, setIsEdit] = useState<boolean>(false);

  const toggleEdit = () => {
    setIsEdit((prev) => !prev);
  };

  useEffect(() => {
    setIsEdit(false);
  }, []);

  let initialValue: { [key: string]: string | ReactSelectOption } = {
    [name]: inputValue,
  };
  if (type === 'select') {
    initialValue = { [name]: { label: inputValue, value: inputValue } };
  }

  const submitHandler = (data: { [key: string]: string | ReactSelectOption }) => {
    if (type === 'select') {
      if (inputValue !== (data[name] as ReactSelectOption).value) {
        onSubmit({ [name]: (data[name] as ReactSelectOption).value });
      }
    } else {
      if (inputValue.toLowerCase() !== (data[name] as string).toLowerCase()) {
        onSubmit(data);
      }
    }
    setIsEdit(false);
  };

  return (
    <HookFormProvider defaultValues={initialValue}>
      <HookForm onSubmit={submitHandler} className='flex justify-between items-center'>
        {isEdit ? (
          <div className='w-1/3'>
            {type === 'select' ? (
              <HookReactSingleSelect id='titleId' options={options} placeholder='Select Title' name={name} />
            ) : (
              <HookInput type='text' name={name} disabled={isLoading} maxLength={maxLength} minLength={minLength} />
            )}
          </div>
        ) : (
          <span className='flex-grow'>{inputValue}</span>
        )}
        {!disabled && (
          <HasPermission of={permission}>
            {!isEdit && (
              <span className='ml-4 shrink-0'>
                <PencilIcon
                  className='h-5 w-5 text-neutralColor-light hover:text-neutralColor-normal cursor-pointer'
                  onClick={toggleEdit}
                />
              </span>
            )}
            {isEdit && (
              <button type='submit' key='submit' disabled={isLoading} className='bg-neutralColor-lightest p-1 rounded-full'>
                <span className='sr-only'>save</span>
                <CheckIcon className='h-5 w-5 text-primaryColor-normal' />
              </button>
            )}
          </HasPermission>
        )}
      </HookForm>
    </HookFormProvider>
  );
};
